<script lang="ts">
  import { accounts } from "$lib/stores/accounts.svelte";
  import { onMount } from "svelte";

  let { value = $bindable<string | null>(null), required = false } =
    $props<{ value?: string | null; required?: boolean }>();

  onMount(async () => {
    await accounts.ensureDefault();
    if (!value && accounts.list[0]) value = accounts.list[0].id;
  });
</script>

<select class="input" bind:value {required}>
  <option value={null}>— Selecione conta —</option>
  {#each accounts.list as a}
    <option value={a.id}>{a.name}</option>
  {/each}
</select>
